import { useLandscapeDisplayInfo } from "@hg/layouts"
import cls from "classnames"
import React, { useEffect, useState } from "react"

import { handleResize } from "@/utils/adaptFont"

import styles from "./index.module.scss"

const Resize: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    const [show, setShow] = useState(false)
    const { width, height } = useLandscapeDisplayInfo()

    useEffect(() => {
        handleResize(width, height, 16)
        setShow(true)
    }, [height, width])

    return <div className={cls(styles.layout, show && styles.show)}>{children}</div>
}

export default Resize
